import { MouseEvent, ReactElement, useEffect } from 'react';

const Modal = ({
  children,
  clickOutside,
}: {
  children: ReactElement;
  clickOutside?: () => void;
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && clickOutside) clickOutside();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [clickOutside]);

  const handleClickOutside = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && clickOutside) {
      clickOutside();
    }
  };

  return (
    <div
      onClick={(e) => handleClickOutside(e)}
      className="fixed top-0 right-0 left-0 w-dvh h-dvh flex justify-center items-center bg-black/90 z-30"
    >
      {children}
    </div>
  );
};

export default Modal;
